import {
  DEFAULT_BRANDED_ACTION_SURFACE_CONTRAST_RATIO,
  getBrandedActionColors,
  getVisibleBrandActionColor,
} from '@wavvest/shared-utils';
import type { AuthColorScheme } from './useAuthTheme';

/** Dark-on-light foreground token used by the auth shell (not pure black). */
const AUTH_DARK_FOREGROUND = '#1f1f24';
const TEXT_ACCENT_CONTRAST_RATIO = 4.5;

// The page and the credential card each scheme paints behind a firm's color.
// Keep these in step with `--auth-page` and `--auth-card` in
// auth-split-layout.scss: a firm color is only adjusted for contrast against
// what it actually sits on.
const AUTH_SURFACES: Record<AuthColorScheme, { page: string; card: string }> = {
  dark: { page: '#0b1015', card: '#0c1016' },
  light: { page: '#ffffff', card: '#ffffff' },
};

const AUTH_HERO_SURFACES: Record<AuthColorScheme, { page: string; card: string }> = {
  dark: { page: '#0b1015', card: '#070a0f' },
  light: { page: '#ffffff', card: '#eef4fa' },
};

export const getAuthBrandActionColors = (brandColor: string, scheme: AuthColorScheme = 'dark') =>
  getBrandedActionColors({
    primaryColor: brandColor,
    surfaceColor: AUTH_SURFACES[scheme].card,
    pageBackgroundColor: AUTH_SURFACES[scheme].page,
    minimumSurfaceContrastRatio: DEFAULT_BRANDED_ACTION_SURFACE_CONTRAST_RATIO,
    foregrounds: { dark: AUTH_DARK_FOREGROUND },
  });

export const getAuthBrandTextColor = (brandColor: string, scheme: AuthColorScheme = 'dark') =>
  getVisibleBrandActionColor({
    primaryColor: brandColor,
    surfaceColor: AUTH_SURFACES[scheme].card,
    pageBackgroundColor: AUTH_SURFACES[scheme].page,
    minimumContrastRatio: TEXT_ACCENT_CONTRAST_RATIO,
  });

export const getAuthBrandHeroAccentColor = (brandColor: string, scheme: AuthColorScheme = 'dark') =>
  getVisibleBrandActionColor({
    primaryColor: brandColor,
    surfaceColor: AUTH_HERO_SURFACES[scheme].card,
    pageBackgroundColor: AUTH_HERO_SURFACES[scheme].page,
    minimumContrastRatio: TEXT_ACCENT_CONTRAST_RATIO,
  });
